"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styles = __importStar(require("../../TourRecap.module.css"));
function Footer(props) {
    return (react_1.default.createElement("div", { className: styles.footerPosition },
        react_1.default.createElement("table", { className: "table " + styles.tableBorder },
            react_1.default.createElement("tbody", null,
                react_1.default.createElement("tr", null,
                    react_1.default.createElement("td", { className: styles.textLeft },
                        react_1.default.createElement("span", null,
                            react_1.default.createElement("b", null,
                                props.pageNumber,
                                "\u200C\u200C"))))))));
}
exports.Footer = Footer;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiRm9vdGVyLmNvbXBvbmVudC5qcyIsInNvdXJjZVJvb3QiOiIuLyIsInNvdXJjZXMiOlsicGRmL2Zvcm1zL2FzaGVyL1RvdXJSZWNhcC9wYXJ0cy9Gb290ZXIvRm9vdGVyLmNvbXBvbmVudC50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7Ozs7O0FBQUEsZ0RBQXlCO0FBRXpCLGlFQUFvRDtBQUVwRCxTQUFnQixNQUFNLENBQUMsS0FBSztJQUN4QixPQUFPLENBQ0gsdUNBQUssU0FBUyxFQUFFLE1BQU0sQ0FBQyxjQUFjO1FBQ2pDLHlDQUFPLFNBQVMsRUFBRSxXQUFTLE1BQU0sQ0FBQyxXQUFhO1lBQzNDO2dCQUNJO29CQUNJLHNDQUFJLFNBQVMsRUFBRSxNQUFNLENBQUMsUUFBUTt3QkFDMUI7NEJBQ0k7Z0NBQUksS0FBSyxDQUFDLFVBQVU7K0NBQU8sQ0FDeEIsQ0FDTixDQUNKLENBQ0QsQ0FDSixDQUNOLENBQ1QsQ0FBQTtBQUNMLENBQUM7QUFoQkQsd0JBZ0JDIn0=